import { Component, Input, OnInit } from '@angular/core';
import { PhoneService, PhoneCall } from '@wephone-app-phone/services';
import { FlexBaseComponent } from '@wephone-core-ui';
import { DialogService } from '@wephone-utils';
import { MyActiveCallsComponent } from '../my-active-calls/my-active-calls';
import { MatDialogRef } from '@angular/material/dialog';
import { _tk, _ti } from '@wephone-translation';

@Component({
  selector: 'call-active-minimized',
  templateUrl: './call-active-minimized.html',
  styleUrls: ['./call-active-minimized.scss']
})
export class CallActiveMinimizedComponent extends FlexBaseComponent implements OnInit {
  @Input() call: PhoneCall;

  callDialog: MatDialogRef<any, any>;

  constructor(private dialogService: DialogService, private phoneService: PhoneService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    const call = this.phoneService.activeCall;

    call.watchHangup(() => {
      if (this.callDialog) {
        this.callDialog.close();
      }
    });
  }

  showActiveCall(): void {
    this.callDialog = this.dialogService.openModal(
      MyActiveCallsComponent,
      {
        disableClose: true,
        size: 'l'
      },
      (ret: any) => {
        this.callDialog = undefined;
      }
    );
  }
}
